import { ApiClient, type RequestOptions } from "@plotlounge/shared/api";

type GetTokenFn = () => Promise<string | null>;

class WebApiClient extends ApiClient {
  private getTokenFn: GetTokenFn | null = null;

  setTokenProvider(fn: GetTokenFn): void {
    this.getTokenFn = fn;
  }

  override async request<T>(
    endpoint: string,
    options: RequestOptions = {},
  ): Promise<T> {
    const headers: Record<string, string> = { ...options.headers };
    const token = this.getTokenFn ? await this.getTokenFn() : null;
    if (token) headers.Authorization = `Bearer ${token}`;
    return super.request<T>(endpoint, { ...options, headers });
  }
}

let singleton: WebApiClient | null = null;

export function getApiClient(baseUrl?: string): WebApiClient {
  if (!singleton) {
    if (!baseUrl) {
      throw new Error(
        "API client not initialized. Pass baseUrl on first call.",
      );
    }
    singleton = new WebApiClient(baseUrl);
  }
  return singleton;
}
